import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../../Seo";
import { SITE_ORIGIN } from "../../../config/site";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import { yandexMetrikaParams } from "../../../analytics/yandexMetrika";
import { NICHE_LANDING_LIST } from "../../Clinic/NicheLanding/nicheLandings";
import MarketingShell from "../MarketingShell";
import { MARKETING_AUDIENCE, MARKETING_PATHS } from "../marketingNav";
import s from "../marketing.module.css";

const PATH = MARKETING_PATHS.forWhom;

export default function ForWhomPage() {
  useEffect(() => {
    yandexMetrikaParams({ landing: "for_whom" });
  }, []);

  const onTry = () => trackTryClick({ landing: "for_whom" });

  return (
    <MarketingShell metrikaLanding="for_whom">
      <Seo
        title="Кому подойдёт Бай.Спорт — секции, школы и тренеры"
        description="CRM для спортивных секций: единоборства, танцы, гимнастика, плавание, футбол и соло-тренеры. Выберите свою нишу."
        canonicalUrl={`${SITE_ORIGIN}${PATH}`}
        keywords={[
          "crm для спортивной секции",
          "программа для школы единоборств",
          "программа для танцевальной школы",
          "crm для тренера",
        ]}
      />

      <section className={s.pageHero}>
        <div className={s.pageHeroInner}>
          <p className={s.eyebrow}>Для кого</p>
          <h1>Кому подойдёт Бай.Спорт</h1>
          <p>
            Не универсальный «фитнес для всех», а учёт секции: журнал, абонементы
            и кабинет родителей. Выберите свою нишу — откроется отдельная
            посадочная.
          </p>
          <div className={s.heroActions}>
            <Link
              to={MARKETING_PATHS.buy}
              className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
              onClick={onTry}
            >
              Попробовать {TRIAL_DAYS} дней
            </Link>
            <Link to={MARKETING_PATHS.pricing} className={`${s.btn} ${s.btnOutline} ${s.btnLg}`}>
              Смотреть тарифы
            </Link>
          </div>
        </div>
      </section>

      {MARKETING_AUDIENCE.map((group) => (
        <section key={group.title} className={s.section}>
          <h2 className={s.sectionTitle}>{group.title}</h2>
          <p className={s.sectionLead}>
            Отдельные страницы под запросы и объявления — как у крупных
            конкурентов, но под секции и школы.
          </p>
          <div className={s.cardGrid}>
            {group.items.map((item) => (
              <Link key={item.to} to={item.to} className={s.card}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}

      <section className={s.section}>
        <h2 className={s.sectionTitle}>Ниши по видам спорта</h2>
        <p className={s.sectionLead}>
          У каждой ниши — свой H1, сценарий и FAQ.
        </p>
        <div className={s.cardGrid}>
          {NICHE_LANDING_LIST.map((n) => (
            <Link key={n.id} to={n.path} className={s.card}>
              <h3>{n.label}</h3>
              <p>{n.sports.join(" · ")}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className={s.ctaBand}>
        <h2>Не нашли свою нишу?</h2>
        <p>
          Продукт один: журнал, абонементы и кабинет. Запустите клуб и
          настройте группы под ваш вид спорта.
        </p>
        <Link
          to={MARKETING_PATHS.buy}
          className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
          onClick={onTry}
        >
          Создать клуб
        </Link>
      </section>
    </MarketingShell>
  );
}
